import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = ['shutdownTypes'];

const shutdownTypesQuery = async () => {
  return await request.get(
    `/Alert/types`,
    {},
    `При загрузке типов отключения произошла ошибка`
  );
};

export const useShutdownTypes = (options) =>
  useQuery(key, shutdownTypesQuery, options);
